<template>
  <div>
    <v-card tile>
        <!-- <v-toolbar flat>
            <v-icon>mdi-pin-outline</v-icon>
            <v-toolbar-title>Address Data</v-toolbar-title>
            <v-spacer />
            <slot name="toolbar" />
        </v-toolbar> -->
        <v-banner single-line>
        <v-avatar slot="icon" color="green lighten-5" size="30">
            <v-icon icon="mdi-information-outline" color="green darken-3" size="20">mdi-information-outline</v-icon>
        </v-avatar>
        Import Data from excel file (simple cities database)
        <v-btn style="color: white;" @click="button_click()" color="green">Import Excel</v-btn>
        </v-banner>
        <input v-show="false" ref="inputUpload" type="file" @change="importExcel" >
    </v-card>
    <generic-view
    title="Countries"
    entity_name="country"
    :headers="headers"
    :localizable_fields="localizable_fields"
    >
    </generic-view>
    <!-- <generic-view
    title="States"
    entity_name="state"
    :headers="headers"
    >
    </generic-view>
    <generic-view
    title="Cities"
    entity_name="city"
    :headers="headers"
    >
    </generic-view> -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import GenericView from './GenericView'
import { objectToFormData } from 'object-to-formdata';
import axios from 'axios'

export default {
  data() {
    return  {
      file:[],
      headers: [
        {
          text: 'Info',
          value: 'selectableInfo',
          type:'textfield',
          hide_in_edit:true
        }
      ],
      localizable_fields: [
        {
          text: 'Name',
          value: 'name',
          type:'textfield'
        }
      ],
      search: '',
      currentStation: {
        name:"",
        description:"",
        coordinate:""
      },
      showEditStation: false
    }
  },
  computed: {
    ...mapState('entities',['entity','entities','loading']),
    ...mapState('settings',['baseApi'])
  },
  components: {
    GenericView
  },
  methods: {
    ...mapActions('entities',['getEntities','saveEntity']),
    importExcel(event) {
        if(this.file.length == 0) this.file = this.$refs.inputUpload.files[0]
        var formData = new FormData()
        formData.append('file', this.file)
        var post_url = `${this.baseApi}/excel/upload`
        console.log(post_url)
        axios.post(post_url, formData)
        .then(response=>{

        })
        .catch(e => {
          console.log(e)
        })
    },
    button_click() {
      if(this.file.length == 0)
        this.$refs.inputUpload.click()
      else this.importExcel()
    }
  },
  mounted() {
    this.getEntities('country')
  }
}
</script>